import React from "react";
import {Col, Row, Spin} from "antd";
import i18next from "i18next";
import * as AuthBackend from "../../services/AuthBackend";
import * as Setting from "../../conf/Setting";
import GlobalContext from "../../context/GlobalContext";

class LogoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      logoutRequest: false,
    };
  }

  UNSAFE_componentWillMount() {
  }

  logout(updateAccount) {
    this.setState({loading: true});
    const params = new URLSearchParams(this.props.location.search);
    const redirect = params.get("redirect_uri");
    this.setState({logoutRequest: true});
    AuthBackend.logout(redirect).then((res) => {
      this.setState({loading: false});
      if (res.status === "ok") {
        updateAccount(null);
        const params = new URLSearchParams(this.props.location.search);
        let redirectUri = params.get("redirect_uri");
        if (redirectUri !== null && redirectUri !== undefined && redirectUri !== "") {
          Setting.showMessage("success", i18next.t("login:Logged out successfully, redirecting"));
          redirectUri = redirectUri + "?state=logoutSuccess";
          Setting.goToLink(redirectUri);
        } else {
          Setting.showMessage("success", i18next.t("login:退出成功"));
          Setting.goToLinkSoft(this, "/logout/result");
        }
      } else {
        Setting.showMessage("error", `${i18next.t("login:Failed to log out")}: ${res.msg}`);
      }
    });
  }

  render() {
    return (
      <GlobalContext.Consumer>
        {
          ({account, updateAccount}) => (
            <Row>
              <Col span={24} style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                {this.state.loading && <div style={{marginTop: "10%"}}>
                  <Spin loading={this.state.loading} size="large" />
                  <span style={{fontSize: 14, marginLeft: 15}}>{i18next.t("account:Account is signing out")}</span>
                </div>}
                {
                  !this.state.logoutRequest ?
                    this.logout(updateAccount)
                    : null
                }
              </Col>
            </Row>
          )
        }
      </GlobalContext.Consumer>
    )
    ;
  }
}

export default LogoutPage;
